import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Result, Button } from 'antd';
import { Navigate, useNavigate } from 'react-router-dom';
import { LOGIN_PATH, ROOT_PAGE_PATH } from '../../routes/path';
import ProtectedRoute from '../protectedRoute';

const AdminProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const { rol } = useSelector((state) => state.userReducer.user);
  const token = useSelector((state) => state.appReducer.token.accessToken);

  // Primero verificar si el usuario está autenticado
  if (!token) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  // Verificar si el usuario tiene rol de administrador o super admin
  const isAdmin = rol === 'admin' || rol === 'superadmin' || rol === 'administrador';

  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Lo siento, no tienes permisos para acceder a esta página. Solo los administradores pueden ver los logs del sistema."
        extra={
          <Button type="primary" onClick={() => navigate(ROOT_PAGE_PATH)}>
            Volver al Inicio
          </Button>
        }
      />
    );
  }

  // Si es admin, usar el ProtectedRoute normal
  return (
    <ProtectedRoute>
      {children}
    </ProtectedRoute>
  );
};

AdminProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminProtectedRoute;
